import styleInject from 'style-inject';
import { collectStyles } from '@lsg/ssr';

var reactStyles = " .lsgs-b1d71--select-flyout{display:block;}.lsgs-b1d71--select-flyout-flyout{max-height:320px;min-width:-moz-min-content;min-width:min-content;}";
var hostClass = "lsgs-b1d71--select-flyout";
styleInject(reactStyles);
collectStyles(reactStyles);

export { hostClass, reactStyles };
